 
import apiServices from "../common/apiServices";

// Define the tag types related to shop-profiles
export const addTagTypes = ['ShopProfiles', 'shop'];

// Enhance the base API service by adding ShopProfiles-related tag types
const ShopApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new shop category (POST request to /shop-profiles)
      createShopProfiles: build.mutation({
        query: ({ shopProfile, userId }) => ({
          url: `/shop-profiles/${userId}`,
          method: 'POST',
          data: shopProfile,  // Using ShopProfile interface data here
        }),
        invalidatesTags: ['ShopProfiles'],  // Invalidate ShopProfiles tags after creation
      }),

      // Get all shop categories (GET request to /shop-profiles)  
      getAllShopProfiles: build.query({
        query: () => ({
          url: '/shop-profiles',
        }),
        providesTags: ['ShopProfiles'],  // Provide ShopProfiles tags to manage cache
      }),
  // Get all shop categories (GET request to /shop-profiles) get_userId
  getAllShopProfilesByUserId: build.query({
    query: (userId) => ({
      url: `/shop-profiles/get/${userId}`,
    }),
    providesTags: ['ShopProfiles'],  // Provide ShopProfiles tags to manage cache
  }),
      // Get a category by ID (GET request to /shop-profiles/{id})
      getShopProfilesById: build.query({
        query: (id) => ({
          url: `/shop-profiles/${id}`,
        }),
        providesTags: ['ShopProfiles'],
      }),
 
      getShopProfilesStatus: build.query({
        query: (userId) => ({
          url: `/shop-profiles/status`,
          method: "GET",
          params: { userId }, // Pass userId as a query parameter
        }),
        providesTags: ["ShopProfiles"],
      }),
// Update documents in a shop profile (PATCH request to /shop-profiles/{id}/documents)
updateShopProfileDocuments: build.mutation({
  query: ({ id, documents }) => ({
    url: `/shop-profiles/${id}/documents`,
    method: 'PATCH',
    data: { documents }, // Send the updated documents array
  }),
  invalidatesTags: ['ShopProfiles'], // Invalidate ShopProfiles tags after update
}),
// Update documents in a shop profile (PATCH request to /shop-profiles/{id}/documents)
updateShopImages: build.mutation({
  query: ({ id, imagesUrls }) => ({
    url: `/shop-profiles/${id}/imagesUrls`,
    method: 'PATCH',
    data: { imagesUrls }, // Send the updated documents array
  }),
  invalidatesTags: ['ShopProfiles'], // Invalidate ShopProfiles tags after update
}),
      getShopProfilesStatusAndProfileId: build.query({
        query: (userId) => ({
          url: `/shop-profiles/statusProfileId/${userId}`,
          }),
        providesTags: ["ShopProfiles"],
      }),
      
     // Endpoint to fetch paginated actions with optional params
getSearchPaginatedProfile: build.query({
  query: ({ shopName = '', page = 0, size = 10}) => {
    const params = new URLSearchParams({
      shopName,                // Automatically encoded
      page: page.toString(),   // Convert to string
      size: size.toString(),   // Convert to string
    });
    
    const url = `/shop-profiles/vendorStoresProfile?${params.toString()}`;
    // console.log('Fetching URL:', url);  // Log the full URL

    return {
      url, // Append query string
      method: 'GET',
    };
  },
}),
      

      // Update shop category (PUT request to /shop-profiles/{id})
      updateShopProfiles: build.mutation({
        query: ({ id, updateDto }) => ({
          url: `/shop-profiles/updateShopProfile/${id}`,
          method: 'PUT',
          data: updateDto,  // Using ShopProfile interface data here
        }),
        invalidatesTags: ['ShopProfiles'],
      }),

     updateShopLogoImage: build.mutation({
  query: ({ shopProfileId, imageLogoUrl }) => ({
    url: `/shop-profiles/${shopProfileId}/logo-image?imageLogoUrl=${encodeURIComponent(imageLogoUrl)}`,  
    method: 'PATCH',
  }),
  invalidatesTags: ['ShopProfiles'],
}),

updateShoCover: build.mutation({
  query: ({ shopProfileId, coverImageUrl }) => ({
    url: `/shop-profiles/${shopProfileId}/cover-image?coverImageUrl=${encodeURIComponent(coverImageUrl)}`,  
    method: 'PATCH',
  }),
  invalidatesTags: ['ShopProfiles'],
}),

      
      // Delete a shop category (DELETE request to /shop-profiles/{id})
      deleteShopProfiles: build.mutation({
        query: (id) => ({
          url: `/shop-profiles/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ShopProfiles'],  // Invalidate ShopProfiles tags after deletion
      }),
    }),
    overrideExisting: false,
  });

export default ShopApi;

// Exporting hooks for each endpoint to be used in components
export const {
  useGetSearchPaginatedProfileQuery,
  useGetShopProfilesStatusQuery,
  useGetShopProfilesStatusAndProfileIdQuery,
  useGetAllShopProfilesByUserIdQuery,
  useCreateShopProfilesMutation,
  useGetAllShopProfilesQuery,
  useGetShopProfilesByIdQuery,
  useUpdateShopProfilesMutation,
  useDeleteShopProfilesMutation,
  useUpdateShopProfileDocumentsMutation,
  useUpdateShopImagesMutation,
  useUpdateShoCoverMutation,
  useUpdateShopLogoImageMutation,
} = ShopApi;

// Type definitions for the API responses and requests
export const defaultShopProfile = {
  id: 0,
  shop_description: '',
  streetAddressShopAddress: '',
  countryShopAddress: '',
  cityShopAddress: '',
  stateShopAddress: '',
  zipShopAddress: '',
  adminCommissionRate: 0,
  shopStatus: '',
  coverImageUrl: '',
  imageLogoUrl: '',
  icon: '',
  url: '',
  latLocation: 0,
  lngLocation: 0,
  cityLocation: '',
  stateLocation: '',
  countryLocation: '',
  zipLocation: '',
  formattedAddressLocation: '',
  createdAt: " ",  // ISO string format
  updatedAt: " ",  // ISO string format
  documents: [''],
  user_id: 0,  // User ID as a number
  ShopProfilesIds: [0]  // Array of category shop IDs
};
export const shopProfile = {
    id: 0,
    shop_description: "string",
    streetAddressShopAddress: "string",
    countryShopAddress: "string",
    cityShopAddress: "string",
    stateShopAddress: "string",
    zipShopAddress: "string",
    adminCommissionRate: 0,
    shopStatus: "string",
    coverImageUrl: "string",
    imageLogoUrl: "string",
    icon: "string",
    url: "string",
    latLocation: 0,
    lngLocation: 0, 
    cityLocation: "string",
    stateLocation: "string",
    countryLocation: "string",
    zipLocation: "string",
    formattedAddressLocation: "string",
    createdAt: "2024-12-27T09:47:52.857Z",  // ISO string format
    updatedAt: "2024-12-27T09:47:52.857Z",  // ISO string format
    documents: ["string"], // store multiple file and image
    user_id: 0,  // User ID as a number
    ShopProfilesIds: [0]  // Array of category shop IDs
  };